import { useGetVisaReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function VisaReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      usePivotQuery={useGetVisaReport}
      title={t('common:visa-report')}
      completeName={['customer', 'admin', 'guest', 'status']}
    />
  );
}
